import { Tooltip } from "@/components/ui/tooltip";
import { AppRoutes } from "@/constants/routes";
import { AppColors } from "@/styles/colors";
import { Button, Text } from "@chakra-ui/react";
import { Check, ChevronLeft, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface Props {
  isPending: boolean;
  canWrite: boolean;
  anyLoading: boolean;
  disableConfirm?: boolean;
  onConfirm: () => void;
  onReject: () => void;
}

export const EstablishmentFieldRequestDetailActions = ({
  isPending,
  canWrite,
  anyLoading,
  disableConfirm = false,
  onConfirm,
  onReject,
}: Props) => {
  const navigate = useNavigate();

  return (
    <>
      {isPending && canWrite && (
        <>
          <Tooltip
            disabled={!disableConfirm}
            openDelay={200}
            closeDelay={100}
            positioning={{ placement: "bottom" }}
            content={
              <Text fontSize="13px">
                Existen solicitudes de servicio activas vinculadas
              </Text>
            }
            contentProps={{ css: { paddingX: "10px", "--tooltip-bg": AppColors.GRAY_TEXT } }}
          >
            <Button
              bgColor={AppColors.GREEN_PRIMARY}
              paddingX="12px"
              height="32px"
              onClick={onConfirm}
              disabled={anyLoading || disableConfirm}
            >
              <Check size={16} />
              <Text fontWeight={600} fontSize="14px">Confirmar</Text>
            </Button>
          </Tooltip>
          <Button
            bgColor={AppColors.ERROR_TEXT}
            paddingX="12px"
            height="32px"
            onClick={onReject}
            disabled={anyLoading}
          >
            <X size={16} />
            <Text fontWeight={600} fontSize="14px">Rechazar</Text>
          </Button>
        </>
      )}
      <Button
        paddingX="8px"
        height="32px"
        onClick={() => navigate(AppRoutes.ESTABLISMENT_FIELD_REQUESTS)}
      >
        <ChevronLeft size={16} />
        Volver
      </Button>
    </>
  );
};
